// extracted by mini-css-extract-plugin
export default {"checkboxIsEnabled":"ConnectionSettingsMarketingEvents_checkboxIsEnabled__Qa6Q5","saveSettingsBtn":"ConnectionSettingsMarketingEvents_saveSettingsBtn__HgXK+"};